import React from 'react';
import { Route } from 'react-router-dom';
import EventsListPage from '../resources/events/pages/EventsListPage';
import DeliveryLogsListPage from '../resources/deliveryLogs/pages/DeliveryLogsListPage';
import SettingsPage from '../resources/settings/pages/Settings';
import SettingsAccessLayout from '../resources/settings/components/SettingsAccessLayout';
import WebhookListPage from '../resources/webhooks/pages/WebhookListPage';
import ManageSigningSecretPage from '../resources/webhooks/components/ManageSigningSecretPage';
import OrgDirectoryListPage from '../resources/orgDirectory/pages/OrgDirectoryListPage';
import ConnectorsListPage from '../resources/connectors/pages/ConnectorsListPage';
import ConnectorDetailPage from '../resources/connectors/pages/ConnectorDetailPage';
import VersionBuilderPage from '../resources/connectors/pages/VersionBuilderPage';
import VersionDetailPage from '../resources/connectors/pages/VersionDetailPage';
import EventsAccessLayout from '../resources/events/components/EventsAccessLayout';
import DeliveryLogsAccessLayout from '../resources/deliveryLogs/components/DeliveryLogsAccessLayout';
import WebhooksConfigAccessLayout from '../resources/webhooks/components/WebhooksConfigAccessLayout';
import AuditLogsAccessLayout from '../resources/auditLogs/components/AuditLogsAccessLayout';
import AuditLogsPage from '../resources/auditLogs/pages/AuditLogsPage';

const AuthenticatedRoutes = () => {
  let configuredFeatures = [];
  configuredFeatures.push(
    <React.Fragment key={'events'}>
      <Route path="/events" element={<EventsAccessLayout />}>
        <Route index element={<EventsListPage />} />
        <Route path=":eventId" element={<EventsListPage />} />
      </Route>
    </React.Fragment>,
  );
  configuredFeatures.push(
    <React.Fragment key={'delivery-logs'}>
      <Route path="/delivery-logs" element={<DeliveryLogsAccessLayout />}>
        <Route index element={<DeliveryLogsListPage />} />
        <Route path=":deliveryLogId" element={<DeliveryLogsListPage />} />
      </Route>
    </React.Fragment>,
  );
  configuredFeatures.push(
    <React.Fragment key={'audit-logs'}>
      <Route path="/audit-logs" element={<AuditLogsAccessLayout />}>
        <Route index element={<AuditLogsPage />} />
      </Route>
    </React.Fragment>,
  );
  configuredFeatures.push(
    <React.Fragment key={'settings'}>
      <Route path="/settings" element={<SettingsAccessLayout />}>
        <Route index element={<SettingsPage />} />
      </Route>
    </React.Fragment>,
  );
  configuredFeatures.push(
    <React.Fragment key={'org-directory'}>
      <Route path="/org-directory" element={<OrgDirectoryListPage />} />
    </React.Fragment>,
  );
  configuredFeatures.push(
    <React.Fragment key={'webhooks'}>
      <Route path="/webhooks" element={<WebhooksConfigAccessLayout />}>
        <Route index element={<WebhookListPage />} />
        <Route path=":webhookId/secret" element={<ManageSigningSecretPage />} />
      </Route>
    </React.Fragment>,
  );
  configuredFeatures.push(
    <React.Fragment key={'connectors'}>
      <Route path="/connectors" element={<ConnectorsListPage />} />
      <Route path="/connectors/:connectorKey" element={<ConnectorDetailPage />} />
      <Route path="/connectors/:connectorKey/versions/:versionNumber/builder" element={<VersionBuilderPage />} />
      <Route path="/connectors/:connectorKey/versions/:versionNumber" element={<VersionDetailPage />} />
    </React.Fragment>,
  );
  return configuredFeatures;
};
export default AuthenticatedRoutes;
